module.exports = __webpack_public_path__ + "img/7_25.0b32f4ad.png";